<template>

  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-search text-primary mr-2"></i>
          Ficha de Búsquedas
        </h4>
      </b-col>
    </b-row>
    <b-row md="12" class="pb-3">

      <b-col class="col-md-12 p-0" v-if="show">

        <b-card class="bg-white w-100 mb-0">
          <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
            Búsquedas
            <div>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm mr-2"
                @click="exportSearch('')">
                <i class="fa fa-download"></i> Exportar todo
              </button>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm mr-2"
                @click="exportSearch('csv')">
                <i class="fa fa-download"></i> CSV
              </button>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm"
                @click="exportSearch('xlsx')">
                <i class="fa fa-download"></i> Excel
              </button>
            </div>
          </b-row>
          <v-server-table
            :columns="columns"
            :options="options"
            :theme="theme"
            id="dataTable"
            ref="dataTable"
            md="12"
            lg="12"
            sm="12">
            <template slot="beforeBody">
              <tr v-if="loading">
                <td class="text-center loading" :colspan="15"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
              </tr>
            </template>
          </v-server-table>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>

  import Vue from 'vue';
  import Multiselect from 'vue-multiselect';
  import {setupCalendar, DatePicker} from 'v-calendar';
  import 'v-calendar/lib/v-calendar.min.css';
  import form from '@/helpers/form';
  import {ServerTable, Event} from 'vue-tables-2';
  import {headingLists} from '@/constants/search-constants';
  import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
  import {downloadJsonAsPdf} from '@/helpers/js-pdf';
  import {getSearchListById} from '@/api/search-api';
  import headquartersSelector from '@/components/headquarters/HeadquartersSelector';
  import Spinner from 'vue-simple-spinner';

  Vue.use(ServerTable);

  setupCalendar({
    firstDayOfWeek: 2,// Monday
  });

  export default {
    name: 'SearchOverview',
    components: {
      'v-date-picker': DatePicker,
      Multiselect,
      headquartersSelector,
      Spinner
    },
    data: function () {
      return {
        topmenu: [],
        request: {
          page: 1,
          itemsPerPage: 10
        },
        orderBy: {
          column: null,
          ascending: null
        },
        count: 0,
        loading: true,
        columns: [],
        show: false,
        entity: "",
        query: "",
        fieldsList: "",
        options: {
          headings: headingLists,
          requestFunction: data => {
            this.request.itemsPerPage = data.limit;
            return axios({
              url: '/search/data',
              method: 'post',
              params: this.request,
              data: {entity: this.entity, searchData: this.query, fields: this.fieldsList}

            }).catch(function (e) {
              this.dispatch('error', e);
            }.bind(this));
          },
          responseAdapter({data}) {
            return {
              data: data.searchResult,
              count: data.count
            }
          },
          filterByColumn: false,
          filterable: false,
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
          texts: null,
          pagination: {
            chunk: 10,
            edge: true,
            nav: 'scroll'
          }
        },
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created() {
      Event.$on('vue-tables.loading', (data) => {
        this.$_loadingMixin_showLoading();
        this.count = 0;
        this.loading = true;
        //this.$refs.dataTable.data = [];
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'none';
        }
      });
      Event.$on('vue-tables.loaded', (data) => {
        if (!!data && !!data.data && !!data.data.count) {
          this.count = data.data.count;
        }
        this.$_loadingMixin_hideLoading();
        this.loading = false;
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'table-row';
        }
      });
      Event.$on('vue-tables.pagination', (page) => {
        this.request.page = page;
      });
      this.$eventHub.$emit('captureMenu', this.topmenu);
      this.getSearchOverview(this.$route.params.uuid);
      this.options.texts = form.tableLabels();
    },
    computed: {
      searchFilters() {
        return {
          string: this.entity.string,
          page: this.entity.page,
          itemsPerPage: this.entity.itemsPerPage
        }
      }
    },
    methods: {
      async getSearchOverview(searchId) {
        this.$_loadingMixin_showLoading();
        await getSearchListById(searchId)
          .then((data) => {
            this.entity = data.entity;
            this.fieldsList = JSON.parse(data.fields);
            this.query = JSON.parse(data.searchData);
            let fields = JSON.parse(data.fields);
            fields.forEach((field, index) => {
              this.columns.push(field.field)
            });
            this.show = true;
            if (!!this.$refs.dataTable) {
              this.$refs.dataTable.refresh();
            }
          });
        this.$_loadingMixin_hideLoading();
      },
      normalizeSearch(data) {
        let myobj = {};
        for (const key in data) {
          Object.assign(myobj, {[`${headingLists[key]}`]: data[key]});
        }
        return myobj;
      },
      async exportSearch(format) {
        if (this.count > 0) {
          this.$_loadingMixin_showLoading();

          let response = await axios({
            method: 'post',
            url: '/search/data',
            params: {
              page: 1,
              itemsPerPage: this.count
            },
            data: {entity: this.entity, searchData: this.query, fields: this.fieldsList}
          });

          let self = this;
          let rows;
          rows = response.data.searchResult.map(function (data) {
            return self.normalizeSearch(data);
          });

          if (format === 'csv') {
            downloadJsonAsCsv(rows);
          } else if (format === 'xlsx') {
            downloadJsonAsXlsx(rows);
          } else {
            downloadJsonAsXlsx(rows)
          }

          this.$_loadingMixin_hideLoading();
        }
      },
    }
  }
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }

    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

  .fit {
    width: 25px;
    white-space: nowrap;
  }

  .VueTables__no-results {
    display: none;
  }
</style>
